import { atom } from 'recoil';

export const therapistsState = atom({
  key: 'therapistsState',
  default: null,
});

export const servicesState = atom({
  key: 'servicesState',
  default: [],
});

export const regionsState = atom({
  key: 'regionsState',
  default: [],
});

export const clinicsState = atom({
  key: 'clinicsState',
  default: [],
});

export const reservationState = atom({
  key: 'reservationState',
  default: null,
});

export const validatedCustomerState = atom({
  key: 'validatedCustomerState',
  default: null,
});

export const tarificationIdState = atom({
  key: 'tarificationIdState',
  default: null,
});

export const jwtTokenState = atom({
  key: 'jwtTokenState',
  default: null,
});

// DEV ONLY: courriel de la connexion simulée (bypass auth dev), null si déconnecté.
export const devBypassEmailState = atom({
  key: 'devBypassEmailState',
  default: null,
});

const availableClinicIdsState = atom({
  key: 'availableClinicIdsState',
  default: [],
});

export default availableClinicIdsState;
